import React from "react";
import {
  formatEffectiveDate,
  formatInvoiceDueDateFromEffectiveDate,
} from "../../utils/utils";
import { useCurrentUser } from "../../slices/auth/hooks";
import { Badge } from "reactstrap";

const InvoicePaymentStatusBadge = ({ invoice }) => {
  const currentUser = useCurrentUser();

  const isAdmin = currentUser?.role === "admin";

  return (
    <Badge
      color={
        invoice?.expired === true
          ? "primary"
          : invoice?.paid || (invoice?.paymentProcessing && !isAdmin)
          ? "success"
          : invoice?.paymentProcessing === true
          ? "warning"
          : "danger"
      }
      style={{
        fontSize: "11px",
      }}
    >
      {invoice?.expired ? (
        <span>Expired</span>
      ) : invoice?.paid || (invoice?.paymentProcessing && !isAdmin) ? (
        "Paid"
      ) : invoice?.paymentProcessing === true ? (
        "Processing"
      ) : (
        `Not Paid`
      )}
    </Badge>
  );
};

export default InvoicePaymentStatusBadge;
